
<template>
    <div v-if="contextMenuDisplay"  ref="contextMenu" :class="['container-context-menu',contextMenuClass]" :style="styleCssToolTip">
        <div class="option" v-for="(option,index) in contextMenuOptions" @click="clickOption(option.name, $event)" v-html="option.label" :key="'option'+index">
            
        </div>
    </div>
</template>


<script>
import store from '@/store/index.js';
import { EventBus } from '@/event-bus';

export default {
    props: {
    },

    data() {
        return {
        observers: [],
        };
    },

    computed: {
        contextMenuDisplay() {
            return this.$store.getters['contextMenu/contextMenuDisplay'];
        },
        contextMenuOptions() {
             return this.$store.getters['contextMenu/contextMenuOptions'];
        },
        contextMenuClass() {
             return this.$store.getters['contextMenu/contextMenuClass'];
        },

        // tooltipPosition() {
        //     return this.$store.getters['tooltip/tooltipPosition'];
        // },

        styleCssToolTip() {
            let event = this.$store.getters['contextMenu/contextMenuEvent'];
            let elementTarget = event.currentTarget

            if (event == null || elementTarget == undefined) return {};

            return {
                left: (event.pageX) + "px",
                top:  (event.pageY) + "px",
            }
        },
    },

    methods: {
        clickOption(name,event) {
            console.log('clickOption',name,event)
            event.stopPropagation();
            EventBus.$emit("receveidEventContextMenu-" + this.$store.getters['contextMenu/contextMenuId'], name);
            this.hideContextMenu()
        },

        handleClickOutside(event) {
            console.log("handleClickOutside", event);
            const targetElement = this.$refs.contextMenu;
            if (!targetElement.contains(event.target)) {
                this.hideContextMenu()
            }
        },

        hideContextMenu() {
            this.$store.commit('contextMenu/updateContextMenuDisplay', false);
        }
    },

    watch : {
        contextMenuDisplay() {
          
            if (this.contextMenuDisplay) {   
                document.body.addEventListener('click', this.handleClickOutside);
                document.body.addEventListener("mouseleave", this.hideContextMenu);
            }else{
                console.log("remove event")
                document.body.removeEventListener("click", this.handleClickOutside, false);
                document.body.removeEventListener("mouseleave", this.hideContextMenu, false);
            }
        }
    },

    beforeDestroy() {
        document.body.removeEventListener("click", this.handleClickOutside, false);
        document.body.removeEventListener("mouseleave", this.hideContextMenu, false);
    },
   

}

</script>

